import { render, staticRenderFns } from "./CampaignStatsOverallReportsBudget.vue?vue&type=template&id=6fd63e91"
import script from "./CampaignStatsOverallReportsBudget.vue?vue&type=script&lang=js"
export * from "./CampaignStatsOverallReportsBudget.vue?vue&type=script&lang=js"
import style0 from "./CampaignStatsOverallReportsBudget.vue?vue&type=style&index=0&id=6fd63e91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports